/* tslint:disable */
/* eslint-disable */
/* @relayHash 85e79d61edd065b1d75f6aaefe767525 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type MessageBannerQueryVariables = {
    userId: string;
    hasRegisteredUserMessages: boolean;
    hasUnregisteredUserMessages: boolean;
    isFirstTimeVisitor: boolean;
    hasPreviewVariables: boolean;
    previewSetId: string;
    previewUserType: string;
};
export type MessageBannerQueryResponse = {
    readonly viewer: {
        readonly user?: {
            readonly registeredUserMessages: ReadonlyArray<{
                readonly " $fragmentRefs": FragmentRefs<"MessageBannerCarousel_messages" | "messageHelpers_messages">;
            } | null> | null;
            readonly " $fragmentRefs": FragmentRefs<"MessageBannerCarousel_user" | "messageHelpers_user">;
        } | null;
        readonly unregisteredUserMessages?: ReadonlyArray<{
            readonly " $fragmentRefs": FragmentRefs<"MessageBannerCarousel_messages" | "messageHelpers_messages">;
        } | null> | null;
        readonly previewMessages?: ReadonlyArray<{
            readonly " $fragmentRefs": FragmentRefs<"MessageBannerCarousel_messages" | "messageHelpers_messages">;
        } | null> | null;
        readonly " $fragmentRefs": FragmentRefs<"MessageBannerCarousel_viewer">;
    };
};
export type MessageBannerQuery = {
    readonly response: MessageBannerQueryResponse;
    readonly variables: MessageBannerQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "hasRegisteredUserMessages",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "hasUnregisteredUserMessages",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "isFirstTimeVisitor",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "hasPreviewVariables",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "previewSetId",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "previewUserType",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "message",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "content",
  "storageKey": null,
  "args": null,
  "concreteType": "MarketingMessageContent",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ]
},
v4 = [
  {
    "kind": "FragmentSpread",
    "name": "MessageBannerCarousel_messages",
    "args": null
  },
  {
    "kind": "InlineDataFragmentSpread",
    "name": "messageHelpers_messages",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "items",
        "storageKey": null,
        "args": null,
        "concreteType": "MessageSetItem",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "note",
            "storageKey": null,
            "args": null,
            "concreteType": "MarketingMessage",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "anchors",
                "storageKey": null,
                "args": null,
                "concreteType": "MarketingMessage",
                "plural": true,
                "selections": [
                  (v3/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  }
],
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currency",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "profile",
  "storageKey": null,
  "args": null,
  "concreteType": "Profile",
  "plural": false,
  "selections": [
    (v5/*: any*/)
  ]
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "buyerDisplayable",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "rate",
  "storageKey": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "convertedAmountList",
      "storageKey": null,
      "args": null,
      "concreteType": "ConvertedAmountList",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "amount",
          "args": null,
          "storageKey": null
        },
        (v5/*: any*/)
      ]
    }
  ]
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "code",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "promotionMeta",
  "storageKey": null,
  "args": null,
  "concreteType": "PromotionMeta",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "customBannerMessage",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "desktopBannerMessage",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "desktopBannerCta",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "mobileBannerMessage",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "mobileBannerCta",
      "args": null,
      "storageKey": null
    }
  ]
},
v11 = [
  {
    "kind": "Variable",
    "name": "isFirstTimeVisitor",
    "variableName": "isFirstTimeVisitor"
  }
],
v12 = [
  {
    "kind": "Variable",
    "name": "setId",
    "variableName": "previewSetId"
  },
  {
    "kind": "Variable",
    "name": "userType",
    "variableName": "previewUserType"
  }
],
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "content",
  "storageKey": null,
  "args": null,
  "concreteType": "MarketingMessageContent",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    (v2/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "cta",
      "storageKey": null,
      "args": null,
      "concreteType": "MarketingMessageCta",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "text",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "url",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
},
v16 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "userType",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "items",
    "storageKey": null,
    "args": null,
    "concreteType": "MessageSetItem",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "impressionCap",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "note",
        "storageKey": null,
        "args": null,
        "concreteType": "MarketingMessage",
        "plural": false,
        "selections": [
          (v14/*: any*/),
          (v15/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "anchors",
            "storageKey": null,
            "args": null,
            "concreteType": "MarketingMessage",
            "plural": true,
            "selections": [
              (v14/*: any*/),
              (v15/*: any*/),
              (v13/*: any*/)
            ]
          },
          (v13/*: any*/)
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "MessageBannerQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "MessageBannerCarousel_viewer",
            "args": null
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasRegisteredUserMessages",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": (v1/*: any*/),
                "concreteType": "User",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": "registeredUserMessages",
                    "name": "bannerMessages",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "MessageSetModule",
                    "plural": true,
                    "selections": (v4/*: any*/)
                  },
                  {
                    "kind": "FragmentSpread",
                    "name": "MessageBannerCarousel_user",
                    "args": null
                  },
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "messageHelpers_user",
                    "selections": [
                      (v6/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "activePromotion",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Promotion",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "flatAdjustmentRate",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "FlatAdjustmentRate",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/)
                            ]
                          },
                          (v9/*: any*/),
                          (v10/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasUnregisteredUserMessages",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "unregisteredUserMessages",
                "name": "messageSet",
                "storageKey": null,
                "args": (v11/*: any*/),
                "concreteType": "MessageSetModule",
                "plural": true,
                "selections": (v4/*: any*/)
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasPreviewVariables",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "previewMessages",
                "name": "messageSet",
                "storageKey": null,
                "args": (v12/*: any*/),
                "concreteType": "MessageSetModule",
                "plural": true,
                "selections": (v4/*: any*/)
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "MessageBannerQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": "promoCodeMessaging",
            "name": "featureFlag",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "promoCodeMessaging"
              }
            ],
            "storageKey": "featureFlag(feature:\"promoCodeMessaging\")"
          },
          (v13/*: any*/),
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasRegisteredUserMessages",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": (v1/*: any*/),
                "concreteType": "User",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "activePromotion",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Promotion",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "flatAdjustmentRate",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FlatAdjustmentRate",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v13/*: any*/)
                        ]
                      },
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v13/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": "registeredUserMessages",
                    "name": "bannerMessages",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "MessageSetModule",
                    "plural": true,
                    "selections": (v16/*: any*/)
                  },
                  (v13/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasUnregisteredUserMessages",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "unregisteredUserMessages",
                "name": "messageSet",
                "storageKey": null,
                "args": (v11/*: any*/),
                "concreteType": "MessageSetModule",
                "plural": true,
                "selections": (v16/*: any*/)
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasPreviewVariables",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "previewMessages",
                "name": "messageSet",
                "storageKey": null,
                "args": (v12/*: any*/),
                "concreteType": "MessageSetModule",
                "plural": true,
                "selections": (v16/*: any*/)
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "MessageBannerQuery",
    "id": "ferrum/262.0.0-2020-04-28T16:33:21.478Z/MessageBannerQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '676b8fb1b79091aaf06388371974c82f';
export default node;
